// extracted by mini-css-extract-plugin
export default {"breadcrumbsRow":"er-z","breadcrumbForward":"fr-z","breadcrumbBack":"gr-z","selected":"hr-z"};